import React, {forwardRef} from 'react';
import {useDispatch} from 'react-redux';

import '../../SetupWizard.scss';
import TipsPickupCalibrationResultAndGuide from 'contents/HardwareSettings/TipsPickupCalibration/TipsPickupCalibrationResultAndGuide';
import {parseMessage} from 'lib/stringHelper';
import {
  runAutoA1OffsetCalibrationAndShowLoading,
  showA1OffsetCalibrationConfirmationModal,
} from 'contents/HardwareSettings/TipsPickupCalibration/TipsPickupCalibrationBusiness';

import SetupWizardStepButton from 'contents/SetupWizard/components/SetupWizardStepButton';
import {checkLoadCellError} from 'stores/business/loadCellErrorBusiness';

const TipsPickupCalibrationSetupWizard = forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const onClickAutoCalibration = async () => {
    const isLoadCellError = await dispatch(checkLoadCellError(null, onClickAutoCalibration));
    if (isLoadCellError) return;
    const callback = () => dispatch(runAutoA1OffsetCalibrationAndShowLoading());

    dispatch(showA1OffsetCalibrationConfirmationModal(callback));
  };

  return (
    <div ref={ref} className="step-a1-offset-calibration-v2">
      <TipsPickupCalibrationResultAndGuide imgGuideSize="33vh" />
      <SetupWizardStepButton
        onClick={onClickAutoCalibration}
        label={parseMessage('setupWizard.step.a1OffsetCalibration.fastV2.firstButton')}
      />
    </div>
  );
});

export default TipsPickupCalibrationSetupWizard;
